module.exports = __webpack_public_path__ + "img/logoPng.07c3ff5b.png";